import { resourceExplorerGranularViewGridDataSelector } from "./resourceExplorerGranularViewGridDataSelector";
import { RootState } from "../../../../../store";

export const resourceExplorerGranularDataCountSelector = (state: RootState) => {
  return resourceExplorerGranularViewGridDataSelector(state)?.length;
};
